import UniCardHead from "@modules/study/common/uni_card_head";
import {
  Grid,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { htmlParse, swalError } from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import { useAuthActions } from "@_recoil/_actions";
import { authAtom } from "@_recoil/_state";
import moment from "moment";
import Link from "next/link";
import { Fragment, useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import { useRecoilValue } from "recoil";
import styles from "./compare_course.module.scss";

export const CompareCourse = () => {
  const profileInfo = useRecoilValue(authAtom);
  const authActions = useAuthActions();
  const [compareData, setCompareData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getCourseList = async () => {
    try {
      setLoading(true);
      const res = await API.get(`/student/compare-course/total-course-info`);
      if (res.data) {
        const resultItems =
          res.data && res.data.length >= 3 ? res.data.slice(0, 3) : res.data;
        setCompareData(resultItems);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  //Handle Course Compare
  const handleCourseCompare = async (courseId) => {
    if (profileInfo && profileInfo.userTypeSlug) {
      await API.post(`/student/compare-course`, { courseId }).then(
        async (resp) => {
          if (!resp.error && resp.data) {
            await authActions.getProfile();
            await getCourseList();
          } else {
            swalError(resp.error);
          }
        }
      );
    }
  };

  //initial data load
  useEffect(() => {
    if (profileInfo) {
      getCourseList();
    }
  }, []);

  const LoadingComponent = () => {
    return (
      <>
        {new Array(10).fill().map((_, i) => {
          const height = i == 0 ? 350 : 50;
          return (
            <div key={i} style={{ marginBottom: "10px" }}>
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={height}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={height}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={height}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={height}
                  />
                </Grid>
              </Grid>
            </div>
          );
        })}
      </>
    );
  };

  return (
    <Fragment>
      <section className={styles.section_hero}>
        <div className="container">
          <div className={styles.wrapper}>
            <h1>Compare Course</h1>
          </div>
        </div>
      </section>
      <section className={styles.section_compare}>
        <div className="container">
          {loading ? (
            <LoadingComponent />
          ) : (
            <div className={`${styles.ceompare_wrapper} compare_wrapper`}>
              {compareData && compareData?.length === 0 ? (
                <div className={styles.noRecordFound}>
                  <h4>You have no compare courses</h4>
                </div>
              ) : (
                <TableContainer className={styles.compare_table_container}>
                  <Table className={styles.compare_head_table}>
                    <TableBody>
                      <TableRow className={styles.compare_head}>
                        <TableCell
                          className={`${styles.compare_head_row} ${styles.head_row_first}`}
                        >
                          <h3 className={styles.compare_heading}>
                            Compare Course
                          </h3>
                          <p className={styles.compare_sub_text}>
                            You Can Compare Up To 3 Courses
                          </p>
                        </TableCell>
                        {compareData &&
                          compareData.length > 0 &&
                          compareData.map((item, index) => {
                            const uniData = {
                              featureImageSrc:
                                item?.course?.university?.featureImage?.src ??
                                "",

                              universityName:
                                item?.course?.university?.universityName,

                              address: `${item?.course?.university?.city
                                ?.name ?? ""}, ${item?.course?.university?.state
                                ?.name ?? ""},  ${item?.course?.university
                                ?.country?.name ?? ""}`,

                              universityType:
                                item?.course?.university?.universityType ?? "",

                              estd: item?.course?.university?.estd ?? "",

                              link: `/study/${item?.course?.university?.country?.slug}/university/${item?.course?.university?.slug}`,
                            };

                            return (
                              <TableCell
                                className={styles.compare_head_row}
                                key={`overview${index}`}
                              >
                                <button
                                  className={styles.compare_cross_btn}
                                  onClick={() => {
                                    handleCourseCompare(item?.course.courseId);
                                  }}
                                >
                                  <FiX />
                                </button>
                                <UniCardHead data={uniData} />
                              </TableCell>
                            );
                          })}
                      </TableRow>

                      <TableRow className={styles.compare_details}>
                        <TableCell className={styles.compare_details_row}>
                          <h3>Course Name</h3>
                        </TableCell>
                        {compareData &&
                          compareData.length > 0 &&
                          compareData.map((item, index) => {
                            return (
                              <TableCell
                                className={styles.compare_details_row}
                                key={`courseName_${index}`}
                              >
                                <Link
                                  legacyBehavior
                                  href={`/study/${item?.course?.university?.country?.slug}/university/${item?.course?.university?.slug}/${item?.course?.slug}`}
                                >
                                  <a
                                    className={styles.course_name}
                                    target="_blank"
                                  >
                                    {item?.course?.courseName ?? ""}
                                  </a>
                                </Link>
                              </TableCell>
                            );
                          })}
                      </TableRow>

                      <TableRow className={styles.compare_details}>
                        <TableCell className={styles.compare_details_row}>
                          <h3>Course Level</h3>
                        </TableCell>
                        {compareData &&
                          compareData.length > 0 &&
                          compareData.map((item, index) => {
                            return (
                              <TableCell
                                className={styles.compare_details_row}
                                key={`clevel_${index}`}
                              >
                                <p className={styles.courseLevelName}>
                                  {item?.course?.courseLevel?.levelName ?? ""}
                                </p>
                              </TableCell>
                            );
                          })}
                      </TableRow>

                      <TableRow className={styles.compare_details}>
                        <TableCell className={styles.compare_details_row}>
                          <h3>Specialization</h3>
                        </TableCell>
                        {compareData &&
                          compareData.length > 0 &&
                          compareData.map((item, index) => {
                            return (
                              <TableCell
                                className={styles.compare_details_row}
                                key={`sp_${index}`}
                              >
                                <p className={styles.course_specialization}>
                                  {item?.course?.specialization
                                    ?.specializationName ?? ""}
                                </p>
                              </TableCell>
                            );
                          })}
                      </TableRow>

                      <TableRow className={styles.compare_details}>
                        <TableCell className={styles.compare_details_row}>
                          <h3>Course Duration</h3>
                        </TableCell>
                        {compareData &&
                          compareData.length > 0 &&
                          compareData.map((item, index) => {
                            return (
                              <TableCell
                                className={styles.compare_details_row}
                                key={`cdur_${index}`}
                              >
                                <p className={styles.course_duration}>
                                  {item?.course?.courseDuration ?? ""} Months
                                </p>
                              </TableCell>
                            );
                          })}
                      </TableRow>

                      <TableRow className={styles.compare_details}>
                        <TableCell className={styles.compare_details_row}>
                          <h3>1st Year Tuition Fees</h3>
                        </TableCell>

                        {compareData &&
                          compareData.length > 0 &&
                          compareData.map((item, index) => {
                            return (
                              <TableCell
                                className={styles.compare_details_row}
                                key={`cdur_${index}`}
                              >
                                <p className={styles.course_fee}>
                                  {item?.course?.tuition?.amountFrom
                                    ? `$${item?.course?.tuition?.amountFrom}`
                                    : ""}

                                  {item?.course?.tuition?.amountTo != "0" &&
                                    ` - ${item?.course?.tuition?.amountTo}`}
                                </p>
                              </TableCell>
                            );
                          })}
                      </TableRow>

                      <TableRow className={styles.compare_details}>
                        <TableCell className={styles.compare_details_row}>
                          <h3>Intake</h3>
                        </TableCell>
                        {compareData &&
                          compareData.length > 0 &&
                          compareData.map((item, index) => {
                            return (
                              <TableCell
                                className={styles.compare_details_row}
                                key={`int_${index}`}
                              >
                                {item.course.intake &&
                                  item.course.intake.length > 0 &&
                                  item.course.intake.map(
                                    (intakeData, index) => (
                                      <div
                                        className={styles.course_fee}
                                        key={`intake${index}`}
                                      >
                                        {intakeData?.session
                                          ?.admissionSessionName && (
                                          <>
                                            {
                                              intakeData?.session
                                                ?.admissionSessionName
                                            }
                                            :
                                          </>
                                        )}{" "}
                                        {intakeData.month}{" "}
                                        {moment().format("Y")}
                                      </div>
                                    )
                                  )}
                              </TableCell>
                            );
                          })}
                      </TableRow>

                      <TableRow className={styles.compare_details}>
                        <TableCell className={styles.compare_details_row}>
                          <h3>Application Fees </h3>
                        </TableCell>
                        {compareData &&
                          compareData.length > 0 &&
                          compareData.map((item, index) => {
                            return (
                              <TableCell
                                className={styles.compare_details_row}
                                key={`fee_${index}`}
                              >
                                <div className={styles.course_fee}>
                                  {item?.course?.applicationFee == "0"
                                    ? "N/A"
                                    : `$${item?.course?.applicationFee}`}
                                </div>
                              </TableCell>
                            );
                          })}
                      </TableRow>

                      <TableRow className={styles.compare_details}>
                        <TableCell className={styles.compare_details_row}>
                          <h3>Exam Score </h3>
                        </TableCell>
                        {compareData &&
                          compareData.length > 0 &&
                          compareData.map((item, index) => {
                            return (
                              <TableCell
                                className={styles.compare_details_row}
                                key={`scor_${index}`}
                              >
                                {item?.course?.exam &&
                                  item?.course?.exam.length > 0 &&
                                  item?.course?.exam.map((ex, index) => {
                                    return (
                                      <div key={`ex${index}`}>
                                        {ex?.examdata?.examName} {ex?.score}
                                      </div>
                                    );
                                  })}
                              </TableCell>
                            );
                          })}
                      </TableRow>

                      <TableRow className={styles.compare_details}>
                        <TableCell className={styles.compare_details_row}>
                          <h3>Ranking </h3>
                        </TableCell>

                        {compareData &&
                          compareData.length > 0 &&
                          compareData.map((item, index) => {
                            return (
                              <TableCell
                                className={styles.compare_details_row}
                                key={`rank${index}`}
                              >
                                {item?.course?.ranking?.length <= 0 ? (
                                  "N/A"
                                ) : (
                                  <Fragment>
                                    {item?.course?.ranking?.map((ritem, j) => {
                                      return (
                                        <Fragment key={j}>
                                          <div>
                                            {ritem?.company?.rankingCompanyName}
                                          </div>
                                          <div
                                            className={styles.ranking_wrapper}
                                          >
                                            {ritem?.courseRankFrom
                                              ? `#${ritem?.courseRankFrom}`
                                              : ""}{" "}
                                            {ritem?.course?.ranking
                                              ?.courseRankFrom &&
                                            ritem?.courseRankTo &&
                                            parseInt(ritem?.courseRankTo) > 0
                                              ? ` - ${ritem?.courseRankTo}`
                                              : parseInt(
                                                  ritem?.course?.ranking
                                                    ?.courseRankTo
                                                ) > 0
                                              ? `# ${ritem?.courseRankTo}`
                                              : ""}
                                          </div>
                                        </Fragment>
                                      );
                                    })}
                                  </Fragment>
                                )}
                              </TableCell>
                            );
                          })}
                      </TableRow>

                      <TableRow
                        className={`${styles.compare_details} } from_texteditor_wrapper`}
                      >
                        <TableCell className={styles.compare_details_row}>
                          <h3>Course Description</h3>
                        </TableCell>

                        {compareData &&
                          compareData.length > 0 &&
                          compareData.map((item, index) => {
                            return (
                              <TableCell
                                className={`${styles.compare_details_row}`}
                                key={`detail${index}`}
                              >
                                {htmlParse(
                                  item.course.courseDescription ?? " "
                                )}
                              </TableCell>
                            );
                          })}
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </div>
          )}
        </div>
      </section>
    </Fragment>
  );
};

export default CompareCourse;
